import { IconButton, Tooltip } from '@material-ui/core';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import React from 'react';

const DeleteItemButton = ({ onClick, tooltip }) => {
  return (
    <IconButton onClick={onClick}>
      {tooltip ? (
        <Tooltip title={tooltip}>
          <RemoveCircleIcon />
        </Tooltip>
      ) : (
        <RemoveCircleIcon />
      )}
    </IconButton>
  );
};

export default DeleteItemButton;
